module.exports = __webpack_public_path__ + "static/media/dwg.f1728b6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/dwg.png
// module id = 2551
// module chunks = 0